import axios from 'axios'
import store from '@/state/store'
import router from '@/router'
import { useErrorStore } from '../stores/error'

axios.defaults.baseURL = process.env.VUE_APP_ETOTEM_API

axios.interceptors.request.use(async function (request) {
    const publico = request.url.split('/')[0] == 'publico'
    if (publico) {
        request.headers.common['idSessao'] = store.state.sessao.idSessao || ''
    }
    return request
})

axios.interceptors.response.use(async function (response) {
    // Qualquer resposta bem-sucedida prova que o servidor voltou.
    const errorStore = useErrorStore()
    if (errorStore.serverError) errorStore.setServerError(false)

    return response
}, async function (error) {
    if (error.response) {
        switch (error.response.status) {
            case 409:
                localStorage.clear()
                location.reload()
                break;
            case 401:
                if (location.pathname !== '/login' || location.pathname !== '/multi-atendimento') {
                    await store.dispatch('auth/signOut').then(() => {
                        router.push({
                            name: 'login',
                            query: {
                                redirect: location.pathname
                            }
                        }).catch(() => { })
                    }).catch(() => { })
                } else if (location.pathname === '/multi-atendimento') {
                    localStorage.clear()
                    location.reload()
                }
                break;
        }
    }    

    const errorStore = useErrorStore()
    errorStore.errorHandler(error, true)
    
    return Promise.reject(error)
})